import {Endpoints} from '../../../../../globals/api/endpoints';

export class PanelsEndpoints extends Endpoints {

  private static readonly PANELS = PanelsEndpoints.VIEWER + '/panels';
  public static readonly PANELS_ENTRY = PanelsEndpoints.PANELS + '/' + PanelsEndpoints.PROJECT_ID;
  public static readonly PANELS_ENTRY_PREVIEW = PanelsEndpoints.PANELS + '/' + PanelsEndpoints.VERSION_ID
    + '/preview';
}
